import { useState } from "react";

import { exportTableView } from "./export.service";
import type { ExportFormat, TableView } from "./export.types";

export interface UseTableExportOptions {
  /** Consulta o conjunto completo do resultado em vigor na tela (AC2). */
  loadView: () => Promise<TableView>;
  onSuccess: (fileName: string) => void;
  onEmpty: () => void;
  onError: (error: unknown) => void;
}

export interface UseTableExportResult {
  isOpen: boolean;
  isExporting: boolean;
  open: () => void;
  close: () => void;
  run: (format: ExportFormat) => Promise<void>;
}

export function useTableExport({
  loadView,
  onSuccess,
  onEmpty,
  onError,
}: UseTableExportOptions): UseTableExportResult {
  const [isOpen, setIsOpen] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  function open() {
    setIsOpen(true);
  }

  function close() {
    if (isExporting) return;

    setIsOpen(false);
  }

  /**
   * Nunca rejeita: a falha mantém o modal aberto para nova tentativa sem passar
   * outra vez pelo menu ⋮ (AC3).
   */
  async function run(format: ExportFormat) {
    setIsExporting(true);

    try {
      const view = await loadView();

      if (view.rows.length === 0) {
        setIsOpen(false);
        onEmpty();
        return;
      }

      onSuccess(exportTableView({ format, view }));
      setIsOpen(false);
    } catch (error) {
      onError(error);
    } finally {
      setIsExporting(false);
    }
  }

  return { isOpen, isExporting, open, close, run };
}
